import type { ReactNode } from 'react';
import type { FadeProps as FadePropsT, CollapseProps as CollapsePropsT } from '@mui/material';
import { Fade, Collapse } from '@mui/material';
type Props = {
  in: boolean;
  FadeProps?: FadePropsT;
  CollapseProps?: CollapsePropsT;
  children: ReactNode;
};
export function FadeAndCollapse({
  in: isIn,
  FadeProps,
  CollapseProps,
  children
}: Props) {
  return <Fade in={isIn} timeout={{
    enter: 1000,
    exit: 250
  }} {...FadeProps} data-sentry-element="Fade" data-sentry-component="FadeAndCollapse" data-sentry-source-file="FadeAndCollapse.tsx">
      <div>
        <Collapse in={isIn} {...CollapseProps} data-sentry-element="Collapse" data-sentry-source-file="FadeAndCollapse.tsx">
          <div>{children}</div>
        </Collapse>
      </div>
    </Fade>;
}